<template>
	<v-app>
		<v-overlay :value="loading" z-index="1000">
			<v-progress-circular
			indeterminate
			size="100"
			></v-progress-circular>
		</v-overlay>
		<mheader></mheader>
		<v-main class="pt-20 main">
			<v-container :fluid="true" class="pm-frame pa-0 pt-0">
				<router-view></router-view>
			</v-container>
		</v-main>
		<mfooter></mfooter>
	</v-app>
</template>

<script>
import mheader from '@/components/layout/store/Header';
import mfooter from '@/components/layout/store/Footer';
import { mapState } from 'vuex';

export default {
	components: {
		mheader, mfooter
	},
	computed: {
		...mapState(['loading'])
	}
}
</script>
 